// @flow

import React from "react";
import classNames from "classnames";

import options from "../utils/options";
import { Checkbox } from "@components";
import type { SchemaTableWidgetProps } from "../types";

type Props = {
  id: any,
  options: any,
  row: any,
  title: any,
  active: any,
  data: any,
  onChange: Function,
};

export function CheckboxWidget(props: Props) {
  function handleChange(isChecked: string) {
    props.onChange(isChecked === "true");
  }

  const disabled = options.resolveBoolean((props.options || {}).disabled, props.row);

  return (
    <Checkbox
      id={`schema-table__checkbox-widget--${props.id}`}
      label={props.title}
      className="checkbox__input"
      disabled={!props.active || disabled}
      checked={props.data}
      onChange={handleChange}
    />
  );
}

export default CheckboxWidget;
